// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CrmUtils from "../CrmUtils.bs.js";
import * as CrmRepoManager from "../../root/crm/to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as TabPropFactory from "../../root/crm/to-be-migrated/routing/TabPropFactory.bs.js";
import * as WorkSpaceStore from "./WorkSpaceStore.bs.js";
import * as CrmRouteManager from "../../root/crm/to-be-migrated/routing/CrmRouteManager.bs.js";
import * as RecordActionModal from "./record-accordon/RecordActionModal.bs.js";
import * as UrlUtils$Catalyst from "../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as WorkSpaceProvider from "./WorkSpaceProvider.bs.js";
import * as RescriptReactRouter from "../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as CircularLoader$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as RecordActionInterceptor from "./record-accordon/RecordActionInterceptor.bs.js";
import * as EventInterceptor$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/custom/iframe/EventInterceptor.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as TabItemComponent$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/custom/tabs/TabItemComponent.bs.js";
import * as BulkUploadTransactionsModal from "../../root/crm/bulk-upload-partner-transactions/view/components/BulkUploadTransactionsModal.bs.js";

function WorkSpaceComponent$TabsRefreshComponent(Props) {
  var refresh = Props.refresh;
  var refreshDurationOpt = Props.refreshDuration;
  var refreshDuration = refreshDurationOpt !== undefined ? refreshDurationOpt : 1000;
  React.useEffect((function () {
          setTimeout((function (param) {
                  return Curry._1(refresh, undefined);
                }), refreshDuration);
          
        }), []);
  return React.createElement(CircularLoader$Catalyst.make, {});
}

var TabsRefreshComponent = {
  make: WorkSpaceComponent$TabsRefreshComponent
};

function getTabOptions(onTabRefresh) {
  return {
          hd: {
            item_label: {
              TAG: /* Text */0,
              _0: "Refresh Tab"
            },
            item_cb: (function (param) {
                return Curry._1(onTabRefresh, undefined);
              })
          },
          tl: /* [] */0
        };
}

function WorkSpaceComponent$TabNavSection(Props) {
  var tabsList = Props.tabsList;
  var activeTabId = Props.activeTabId;
  var onTabSelectCB = Props.onTabSelectCB;
  var onTabCloseCB = Props.onTabCloseCB;
  var onTabRefresh = Props.onTabRefresh;
  return React.createElement("div", {
              className: "tabs__list"
            }, ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, tab) {
                        return React.createElement(TabItemComponent$Catalyst.make, {
                                    label: tab.label,
                                    isActive: activeTabId === tab.url.hash,
                                    onTabSelectCB: (function (param) {
                                        return Curry._1(onTabSelectCB, tab.url.hash);
                                      }),
                                    onTabCloseCB: (function (param) {
                                        return Curry._1(onTabCloseCB, tab.url.hash);
                                      }),
                                    tabIndex: index,
                                    tabOptions: getTabOptions(onTabRefresh),
                                    showCancelButton: tab.showCancelButton,
                                    key: tab.url.hash
                                  });
                      }), tabsList)));
}

var TabNavSection = {
  getTabOptions: getTabOptions,
  make: WorkSpaceComponent$TabNavSection
};

function getTabStyle(isActiveTab) {
  if (isActiveTab) {
    return {
            display: "block"
          };
  } else {
    return {
            display: "none"
          };
  }
}

function getTabCss(isActiveTab) {
  if (isActiveTab) {
    return "display-tab";
  } else {
    return "no-display-tab";
  }
}

function WorkSpaceComponent$ActiveTabContent(Props) {
  var tabsList = Props.tabsList;
  var activeTabId = Props.activeTabId;
  var refreshTab = Props.refreshTab;
  var dispatch = Props.dispatch;
  if (refreshTab) {
    return React.createElement(WorkSpaceComponent$TabsRefreshComponent, {
                refresh: (function (param) {
                    return Curry._1(dispatch, /* RefreshTab */0);
                  })
              });
  } else {
    return ReasonReactUtils$Catalyst.listToReactArray(List.map((function (tab) {
                      var isActiveTab = activeTabId === tab.url.hash;
                      return React.createElement("div", {
                                  key: tab.url.hash,
                                  className: isActiveTab ? "display-tab" : "no-display-tab",
                                  style: getTabStyle(isActiveTab)
                                }, tab.component);
                    }), tabsList));
  }
}

var ActiveTabContent = {
  getTabStyle: getTabStyle,
  getTabCss: getTabCss,
  make: WorkSpaceComponent$ActiveTabContent
};

function getUserRoles(param) {
  var RepoInstance = CrmRepoManager.getWorkSpaceRepo(undefined);
  return Curry._1(RepoInstance.fetchUserRoles, undefined);
}

function WorkSpaceComponent(Props) {
  var initialTab = Props.initialTab;
  var newTab = TabPropFactory.createCRMTab(undefined, initialTab);
  var initialState_tabsList = {
    hd: newTab,
    tl: /* [] */0
  };
  var initialState_activeTabId = newTab.url.hash;
  var initialState = {
    tabsList: initialState_tabsList,
    activeTabId: initialState_activeTabId,
    refreshTab: false
  };
  var match = React.useReducer(WorkSpaceStore.reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var current_url = RescriptReactRouter.useUrl(undefined, undefined);
  var handleRouteChange = function (param) {
    var tabProps = WorkSpaceStore.getActiveTab(state.activeTabId, state.tabsList);
    if (CrmUtils.isURLSame(current_url, tabProps.url, false)) {
      return ;
    } else {
      return RescriptReactRouter.push(window.encodeURI(CrmUtils.getCrmUrl(tabProps.url)));
    }
  };
  var handleEventRedirect = function (eventPayload) {
    var path = window.decodeURIComponent(eventPayload.path);
    var match = UrlUtils$Catalyst.getHostName(path) === UrlUtils$Catalyst.getCurrentPageHost(undefined);
    var match$1 = CrmRouteManager.getCrmTab({
          path: $$Array.to_list(UrlUtils$Catalyst.getPathSplitParts(path)),
          hash: "",
          search: UrlUtils$Catalyst.getSearchParams(path)
        });
    if (match && match$1 !== undefined) {
      return Curry._1(dispatch, {
                  TAG: /* AddTab */0,
                  _0: match$1,
                  _1: true
                });
    }
    var tab_0 = eventPayload.path;
    var tab_1 = eventPayload.title;
    var tab = {
      TAG: /* InternalRedirectPath */22,
      path: tab_0,
      title: tab_1
    };
    return Curry._1(dispatch, {
                TAG: /* AddTab */0,
                _0: tab,
                _1: true
              });
  };
  var match$1 = RecordActionInterceptor.useRecordActionEvents(undefined);
  var setRecordActionType = match$1[1];
  var recordAction = match$1[0];
  var closeActionModal = function (param) {
    return Curry._1(setRecordActionType, /* Blank */1);
  };
  var getRecordActionComponentSection = function (param) {
    if (typeof recordAction === "number") {
      if (recordAction !== 0) {
        return null;
      } else {
        return React.createElement(BulkUploadTransactionsModal.make, {
                    closeCreateTransactionModal: closeActionModal
                  });
      }
    } else {
      return React.createElement(RecordActionModal.make, {
                  modalComponent: null,
                  onClose: closeActionModal
                });
    }
  };
  React.useEffect((function () {
          var watcherID = RescriptReactRouter.watchUrl(function (url) {
                var crmTab = CrmRouteManager.getCrmTab(url);
                if (crmTab !== undefined) {
                  return Curry._1(dispatch, {
                              TAG: /* AddTab */0,
                              _0: crmTab,
                              _1: false
                            });
                }
                
              });
          return (function (param) {
                    return RescriptReactRouter.unwatchUrl(watcherID);
                  });
        }), []);
  var eventPayload = EventInterceptor$Catalyst.useIframeEvents(undefined);
  React.useEffect((function () {
          if (Object.keys(eventPayload).length !== 0) {
            handleEventRedirect(eventPayload);
          }
          
        }), [eventPayload]);
  React.useEffect((function () {
          handleRouteChange(undefined);
          
        }), [
        state.activeTabId,
        state.tabsList
      ]);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "tabs__container"
                }, React.createElement(WorkSpaceComponent$TabNavSection, {
                      tabsList: state.tabsList,
                      activeTabId: state.activeTabId,
                      onTabSelectCB: (function (hash) {
                          return Curry._1(dispatch, {
                                      TAG: /* SetActiveTab */3,
                                      _0: hash
                                    });
                        }),
                      onTabCloseCB: (function (hash) {
                          return Curry._1(dispatch, {
                                      TAG: /* RemoveTab */1,
                                      _0: hash
                                    });
                        }),
                      onTabRefresh: (function (param) {
                          return Curry._1(dispatch, /* RefreshTab */0);
                        })
                    }), getRecordActionComponentSection(undefined), React.createElement(WorkSpaceProvider.make, WorkSpaceProvider.makeProps({
                          addTab: (function (tab, forceAdd) {
                              return Curry._1(dispatch, {
                                          TAG: /* AddTab */0,
                                          _0: tab,
                                          _1: forceAdd
                                        });
                            }),
                          replaceTab: (function (tab) {
                              return Curry._1(dispatch, {
                                          TAG: /* ReplaceTab */2,
                                          _0: tab
                                        });
                            }),
                          user_roles: getUserRoles(undefined).user_roles,
                          toggleTabCancelCTA: (function (uId) {
                              return Curry._1(dispatch, {
                                          TAG: /* ToggleTabCancelCTA */4,
                                          _0: uId
                                        });
                            })
                        }, React.createElement(WorkSpaceComponent$ActiveTabContent, {
                              tabsList: state.tabsList,
                              activeTabId: state.activeTabId,
                              refreshTab: state.refreshTab,
                              dispatch: dispatch
                            }), undefined))));
}

var make = WorkSpaceComponent;

export {
  TabsRefreshComponent ,
  TabNavSection ,
  ActiveTabContent ,
  getUserRoles ,
  make ,
  
}
/* react Not a pure module */
